import { render } from "./boundday.vue?vue&type=template&id=27b6b0ef"
import script from "./boundday.vue?vue&type=script&lang=js"
export * from "./boundday.vue?vue&type=script&lang=js"

import exportComponent from "D:\\AICodeSpace\\KaungAdmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__